import m from 'm';
import reactCreator from 'components/react.creator';

export default {
  view: () => m(reactCreator, {
    component: 'TwoFactor',
    props: {},
  }),
};
